/*eslint-disable*/
import ConversationApi from '../../api/communication/conversation';
import MessageApi from '../../api/communication/message';
import Api from '../../api/index';
import _ from 'lodash';
import UserApi from "../../api/user/user";
import {mapState} from "vuex";

export default {
    computed: {
        ...mapState({
            currentUser: state => state.auth.user,
        }),
    },
    mounted() {
        this.$echo.private(`message.${this.user.id}`).listen('NewMessage', data => {
            data = Api.convertObjectKeys(data);
            if (this.$route.fullPath.indexOf('/conversations/') !== -1 || this.messages) {
                if (this.conversation && data.message.conversationId === this.conversation.id) {
                    let message = data.message.conversation.lastMessage;
                    this.messages.push(message);
                    this.$nextTick(() => {
                        if (this.$refs[message.id]) {
                            this.$refs[message.id][0].scrollIntoView();
                        }
                    });
                    if (this.$route.fullPath === `/conversations/${this.conversation.id}`) {
                        ConversationApi.update(this.conversation.id, {readAt: true});
                    }
                } else {
                    MessageApi.list({
                        conversationId: data.message.conversationId,
                        amountOfElements: 2
                    }).then(data => {
                        if (data.data.length && (data.data.length === 1 || !data.data[1].unread)) {
                            this.amountOfUnread++;
                        }
                    })
                }
            } else if (this.conversations) {
                let conversation = data.message.conversation;
                conversation.lastMessage.unread = conversation.lastMessage.sender.id !== this.user.id;
                let index = this.conversations.findIndex(item => item.id === conversation.id);
                if (index !== -1) {
                    if (!this.conversations[index].lastMessage.unread && conversation.lastMessage.unread) {
                        this.amountOfUnread++;
                    }
                    this.conversations[index].lastMessage = conversation.lastMessage;
                    this.conversations.unshift(this.conversations[index]);
                    this.conversations = _.uniqBy(this.conversations, 'id');
                } else {
                    let isCanGetMessage = Object.values(conversation.users).find((user) => { return user.id == this.user.id });
                    if (isCanGetMessage && this.currentUser.id == this.user.id) {
                        ConversationApi.show(conversation.id)
                            .then(conversation => {
                                if (this.current !== 'Архив') {
                                    this.conversations.unshift(conversation);
                                    this.conversations = this.conversations.slice(0, this.amount ? this.amount : 15);
                                }
                                return MessageApi.list({
                                    conversationId: conversation.id,
                                    amountOfElements: 2
                                })
                            })
                            .then(data => {
                                if (data.data.length && (data.data.length === 1 || !data.data[1].unread) && conversation.lastMessage.unread) {
                                    this.amountOfUnread++;
                                }
                            })
                    }
                }
            }
        });
    }
}
